export default __webpack_public_path__ + "static/media/sad_man.bcbd9536.png";